<app-modal-box class="modal" [gapValue]="'0'" [maxWidth]="488" [noOverflow]="true">
  <h4>You won <app-icon icon="coin" [width]="20"></app-icon> <app-currency [size]="20" [value]="data.value"></app-currency>on Coinflip #{{ data.gameid }}</h4>
  <p class="modal-description">
    Choose what to do with your winnings. <br />
    Rehost your winnings for a <span class="highlight">0% tax</span> on the previous coinflip!
  </p>
  @if (data.winner) {
  <div class="user-wrapper">
    <div class="user">
      <div class="avatar-wrapper">
        <img class="avatar" [src]="data.winner.avatar" width="56" height="56" />
        <app-coinflip-coin [side]="data.winner" [size]="24" [anim]="false" class="coinflip-coin"></app-coinflip-coin>
      </div>
      <div class="right-side">
        <div class="user-info">
          {{ data.winner.name }}
          <app-level-new [level]="data.winner.level" class="user-level badge badge_rounded badge_font-l"></app-level-new>
        </div>
        <div class="value-wrapper">
          <app-icon [width]="16" [icon]="'coin'"></app-icon>
          <app-currency [animation]="true" [size]="16" [value]="winValue" [symbol]="'+'"></app-currency>
        </div>
      </div>
    </div>
  </div>
  }
  <div class="items-wrapper skins-shadow">
    <div class="items">
      <app-item-list [items]="data.allSkins"></app-item-list>
    </div>
  </div>

  <div class="coins">
    <div class="coin-box blue" [class.selected]="selectedCoin === blueSide" (click)="selectCoin(blueSide)">
      <app-coinflip-coin [size]="24" [side]="'blue'"></app-coinflip-coin>
    </div>
    <div class="coin-box red" [class.selected]="selectedCoin === redSide" (click)="selectCoin(redSide)">
      <app-coinflip-coin [size]="24" [side]="'orange'"></app-coinflip-coin>
    </div>
  </div>
  <div class="actions">
    <button class="button green medium-2 font-default-bold" (click)="doubleDownButton()">Double Down (X2)</button>
    <div class="claim-winnings">
      <p class="claim-winnings-text">
        Auto-claim in 00:<span class="highlight">{{ remainingTime === 10 ? null : 0 }}{{ remainingTime }}</span>
      </p>
      <button class="button black medium-2 font-default-bold" (click)="claimWinningsButton()">Claim Winnings</button>
    </div>
  </div>
</app-modal-box>
